// @ts-ignore
import Lottie from "react-lottie";
import "./Loading.scss";
import lottieIcon from "../../assets/loading-spinner.json";

export const LoadingSpinner = ({ width, height }: any) => {
  return (
    <div className="loading">
      <Lottie
        height={height ?? 100}
        width={width ??100}
        options={{
          loop: true,
          autoplay: true,
          animationData: lottieIcon,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
          },
        }}
      />
    </div>
  );
};
